export const SVN_COOKIE_NAME = 'svn';
export const COOKIE_CUSTOMER_ID_NAME = 'cauid';
export const INIT_TIMEOUT_MS = 1000;
export const UTM_ATTRIBUTES_MAP = [
  ['utm_source', 'utmSource'],
  ['utm_medium', 'utmMedium'],
  ['utm_campaign', 'utmCampaign'],
];
